import { useState, useEffect } from 'react';
import { 
    default as MorningstarSustainabilityRatingExternal,
} from "src/MarketDataComponents/MorningstarSustainabilityRatingExternal";

export default function MorningstarSustainabilityRating({ratings}) {
    
    return <div className="card z-depth-0 margin-0">
        <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm padding-bottom-0">
            {ratings && ratings.sustainabilityRating ? <>
                    <h2 className="card-title" data-testid="morningStarSustainabilityRatingHeader">
                        Morningstar sustainability rating
                        <sup className="h7"><small>TM</small></sup>
                    </h2>
                    <MorningstarSustainabilityRatingExternal rating={ratings.sustainabilityRating}/>
                    <hr />
                </> : null}
        </div>
    </div>

}